module.exports = __webpack_public_path__ + "static/IMG_2190-ccaeaf2e074c85cf37a1f4710cc60b2f.jpg";